import { Location } from '@angular/common';
import { inject, Service } from '@angular/core';

@Service()
export class SourceLocationService {
  readonly #location = inject(Location);

  #sourceUrlKey = 'academy_oauth_source_url';

  store() {
    const [path] = this.#location.path().split(/[?#]/);
    localStorage.setItem(this.#sourceUrlKey, path || '/');
  }

  get() {
    return localStorage.getItem(this.#sourceUrlKey);
  }

  clear() {
    localStorage.removeItem(this.#sourceUrlKey);
  }
}
